export const REDO_ADMIN_SERVER_URL =
  process.env.REDO_ADMIN_SERVER_URL || "http://localhost:8005/";

export const REDO_MERCHANT_APP_URL =
  process.env.REDO_MERCHANT_APP_URL || "http://localhost:3003";

const AMPLITUDE_REPLAY_BASE =
  "https://app.amplitude.com/analytics/redo/session-replay/project/800590/search/replay";

export function getAnalyticsReplayUrl(
  sessionId: string | null | undefined,
): string | null {
  const normalized = sessionId?.trim();
  if (!normalized) {
    return null;
  }
  return `${AMPLITUDE_REPLAY_BASE}?sessionReplayId=${normalized}`;
}

export const REDO_CHAT_WIDGET_URL =
  process.env.REDO_CHAT_WIDGET_URL || "http://localhost:3008";
